import {API} from "../api/api";
import clientFactory from "../factories/http_client";

class ProjectLinkService {

	/** @return  Promise<AxiosResponse<T>> */
	get = (projectId, linkId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.links.id.method,
			                             url: API.data.projects.id.links.id.url(projectId, linkId)
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	create = (projectId, link) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.links.create.method,
			                             url: API.data.projects.id.links.create.url(projectId),
			                             data: API.data.projects.id.links.create.build(link),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (projectId, link) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.links.save.method,
			                             url: API.data.projects.id.links.save.url(projectId),
			                             data: API.data.projects.id.links.save.build(link),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (projectId, linkId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.projects.id.links.delete.method,
			                             url: API.data.projects.id.links.delete.url(projectId),
			                             data: API.data.projects.id.links.delete.build(linkId),
		                             });
	};
}

export default ProjectLinkService;